export default "__VITE_ASSET__1lD_ikrW__"